import { useEffect, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { media, useMediaMatch } from '@storefront/lib-global';
import { useSizeAndWidthContext } from '../../../context';
import { scrollIntoView } from '../../../utils/scrollIntoView';
import { ErrorMessage } from '../errorMessage/ErrorMessage';
import { Widths } from '../widths/Widths';
import { WidthContainer, WidthLabel } from './WidthSelector.styles';

const WIDTH_SCROLL_TOP_MARGIN = 33;

export function WidthSelector() {
  const { t } = useTranslation(['lib-products-common']);
  const { error, uniqueWidths } = useSizeAndWidthContext();
  const widthSelectorContainer = useRef<HTMLDivElement>(null);
  const isDesktop = useMediaMatch(media.greaterThan('lg'));

  useEffect(() => {
    if (error.includes('width') && !error.includes('size')) {
      scrollIntoView(widthSelectorContainer, isDesktop, WIDTH_SCROLL_TOP_MARGIN);
    }
  }, [error, isDesktop]);

  if (uniqueWidths.length < 1) return null;

  return (
    <WidthContainer ref={widthSelectorContainer} data-testid="widthsContainer">
      <WidthLabel>{t('width.selector.select.width')}:</WidthLabel>
      <Widths />
      {error.includes('width') ? (
        <ErrorMessage testId="noWidthSelectedError">{t('width.selector.error.message')}</ErrorMessage>
      ) : null}
    </WidthContainer>
  );
}

export default WidthSelector;
